import React from "react";
import { MrSelect, MrCrudView, FormRenderer } from "mr_react_framework";
import { actions } from "./redux";
import QuestionbanksList from "./QuestionbanksList/QuestionbanksList";
// import BoardsFilter from "./BoardsFilter/BoardsFilter";
// import WrappedMrForm from "../../lib/utils/MrForm/MrForm";
import commonSelectors from "/src/App/commonSelectors";
import { actions as genericActions } from "/src/App/genericRedux";
import {
  GenericWidgetCreator,
  SelectProgrammeSubject,
  SelectSubject as SelectOrgSubject
} from "/src/components/AppSpecific/SelectSubject/SelectSubject";
import { currentUserSelector } from "../Auth/Login/selector";
import { useSelector } from "react-redux";
import MrTranslate, { mrTranslate, useTranslate } from "/src/lib/MrTranslate/MrTranslate";
import SelectOrgDropdown from "/src/components/AppSpecific/SelectOrg/SelectOrgDropdown";
import { orgProgrammesSelector } from "../OrgProgrammes/selector";
import { programmesSelector } from "../Programmes/selector";
import { isStringEmpty } from "/src/lib/utils/helperMethods";

const SelectProgram = MrSelect({
  actions: genericActions,
  resourceName: "programmes",
  config: {
    url: "/programmes",
    params: { should_serialize: false },
    processData: (data, props) => {
      return data.map((item) => {
        return { label: item.abbr, value: item.id };
      });
    },
    widgetConfig: {
      showSearch: false, // if false, this will either load entire data from backend on widget load or onSearch
      // TBD: If false, need to be able to search. Also if can do regular select from redux with this component, then can use same everywhere.
      placeholder: "Select programme",
      // mode: "multiple",
      style: { width: "500px" },
    },
  },
});

const SelectOrgProgram = MrSelect({
  actions: genericActions,
  resourceName: "orgprogrammes",
  apiResourceName: "org_programmes",
  config: {
    url: "/org_programmes",
    params: { should_serialize: false }, //default is org_id on BE
    processData: (data, props) => {
      const { disableMBIntegratedProgrammes } = props
      console.log("data select groups", data);
      console.log("props select groups", props);
      return data.map((item) => {
        console.log("class selector item", item);

        let disabled = false
        if (disableMBIntegratedProgrammes && item.settings?.mb_integration_enabled !== false) {
          disabled = true
        }

        return {label: item.name, value: item.programme_id, disabled: disabled, key: item.id};
      });
    },
    searchApi: false,
    widgetConfig: {
      className: "select-program",
      showSearch: true, 
      filterOption: true,
      optionFilterProp: "label",
      placeholder: <MrTranslate id={"CommonText.select_program"}/>,
      // placeholder: "Select program",
      allowClear: true,
      dropdownMatchSelectWidth: false,
      // mode: "multiple",
      // style: {width: "400px"},
    },
  }
});

const SelectSubjectWidget = GenericWidgetCreator((props) => {
  return {
    config: {
      forceReload: true,
      params: {
        by_type_c: "group",
        by_programme_id: props.formInstance.getFieldValue("programme_id"),
      },
    },
  };
}, SelectProgrammeSubject);

const SelectOrgSubjectWidget = GenericWidgetCreator((props) => {
  console.log("SelectOrgSubjectWidget props ====>", props);
  const programmeId = props.formInstance.getFieldValue("programme_id")
  const allOrgProgrammes = useSelector(orgProgrammesSelector())
  const orgProgramme = allOrgProgrammes.find((item) => item.programme_id === programmeId) || {}
  // setInitialValue: true,

  return {
    config: {
      forceReload: true,
      params: {
        by_type_c: "group",
        by_org_programme_id: orgProgramme.id,
      },
    },
  };
}, SelectOrgSubject);

const getSelectSubjectField = (sourceValues) => {
  console.log("getSelectSubjectField sourceValues", sourceValues);
  return {
    type: "object",
    properties: {
      // subject_id: {
      //   placeholder: "Select subject",
      //   type: "string",
      //   span: 24,
      //   setInitialValue: true,
      //   widget: SelectSubjectWidget,
      // },
      questionbank_programme_subjects: {
        type: "array",
        title: "Programme Subjects",
        addButtonTitle: "+ Add Subject",
        span: 24,
        min: 1,
        max: 100,
        default: [{}],
        items: {
          type: "object",
          properties: {
            programme_subject_id: {
              type: "string",
              title: "Subject",
              widget: SelectSubjectWidget,
              span: 8,
              rules: [{
                required: true,
                message: "Please select subject",
              }]
            },
          },
        },
      },
    },
  };
};

const getOrgSelectSubjectField = (sourceValues) => {
  console.log("getOrgSelectSubjectField sourceValues", sourceValues);
  return {
    type: "object",
    properties: {
      questionbank_programme_subjects: {
        type: "array",
        title: "Subjects",
        addButtonTitle: "+ Add Subject",
        span: 24,
        min: 1,
        max: 100,
        default: [{}],
        items: {
          type: "object",
          properties: {
            subject_id: {
              type: "string",
              title: "Subject",
              widget: SelectOrgSubjectWidget,
              span: 8,
              rules: [{
                required: true,
                message: "Please select subject",
              }]
            },
          },
        },
      },
    },
  };
};

const QBProgrammeSubjectsChildComponent = ({
  getFieldValue,
  sourceValues,
  formInstance
}) => {
  const programmeId = getFieldValue(["programme_id"]);
  const allProgrammes = useSelector(orgProgrammesSelector())
  const currentUser = useSelector(currentUserSelector());
  const isDistrict = currentUser.org.org_type === "district"
  const programmeCodes = ["hs", "ms", "ps", "fs"]
  const currentProgramme = allProgrammes.find((item) => item.programme_id === programmeId) || {}
  const shouldShowOrgSubjects = isDistrict && programmeCodes.includes(currentProgramme.code)
  console.log("currentProgramme ====>", currentProgramme);
  
  let finalRender = null;
  
  if (programmeId) {
    finalRender = (
      <FormRenderer
        formObj={shouldShowOrgSubjects ? getOrgSelectSubjectField(sourceValues) : getSelectSubjectField(sourceValues)}
        sourceValues={sourceValues}
        formInstance={formInstance}
      />
    );
  }
  return finalRender;
};

const SelectOrgsChildComponent = ({ getFieldValue, sourceValues, formInstance }) => {
  const currentUser = useSelector(currentUserSelector());
  const mrIntl = useTranslate();
  const isDistrict = currentUser.org.org_type === "district"
  let finalRender = null;
  console.log("isDistrict ====>", isDistrict, currentUser);

  if (isDistrict) {
    finalRender = (
      <FormRenderer
        formObj={{
          type: "object",
          properties: {
            selected_orgs: {
              title: mrIntl("Questionbanks.select_orgs"),
              type: "string",
              span: 24,
              placeholder: mrIntl("Questionbanks.select_orgs"),
              setInitialValue: true,
              widget: SelectOrgDropdown,
              widgetConfig: {
                mode: "multiple",
                style: { width: "600px" },
                config: {
                  searchApi: false,
                  params: {
                    by_parent_id: currentUser.org_id,
                    with_nested_children: true,
                    should_serialize: true,
                    page_size: 50, 
                  }
                }
              },
            },
          }
        }}
        sourceValues={sourceValues}
        formInstance={formInstance}
      />
    );
  }
  return finalRender;
};

const returnForm = (props) => {
  const { currentUser = {}, intl } = props;
  const mrIntl = mrTranslate(intl); 
  const org = currentUser.org || {};
  const isDistrict = org.org_type === "district" 
  
  let form = {
    processFormData: (dataProps, opts = {}) => {
      const { values } = opts;

      if (isDistrict) {
        // In case of district, we store the org_id of the user who created the question bank in created_by_org_id field
        if(!values.created_by_org_id) {
          values.created_by_org_id = currentUser.org_id;
        }

        // In case of district, we are removed code field form UI and generating code from title automatically
        values.code = values.title.toLowerCase().replace(/\s+/g, '_');
        const selectedOrgIds = values.selected_orgs || [];
        
        // In case of district, we are adding the org_id of the user who created the question bank to the selected orgs for create org questionbank for current org also
        if(!selectedOrgIds.includes(currentUser.org_id)) {
          selectedOrgIds.push(currentUser.org_id);
        }
        console.log("values ====>", values);
        if (values.id) {
          const orgQuestionbanks = [];

          // Update the org questionbank for the selected orgs
          if(values.org_questionbanks) {
            selectedOrgIds.forEach((org_id) => {
              const existingOrg = values.org_questionbanks.find((item) => item.org_id === org_id);
              if (!existingOrg) {
                orgQuestionbanks.push({ org_id, questionbank_id: values.id });
              }
            });

            // Archive the org questionbank if the org is not in the selected orgs
            values.org_questionbanks.forEach((item) => {
              if (!selectedOrgIds.includes(item.org_id)) {
                orgQuestionbanks.push({
                  ...item,
                  archived: true
                });
              }
            });
          }

          values.org_questionbanks_attributes = orgQuestionbanks;
        } else {
          // Handle new question bank
          values.org_questionbanks_attributes = selectedOrgIds.map((org_id) => ({
            org_id
          }));
        }
        delete values.selected_orgs;
      }
      
      values.questionbank_programme_subjects_attributes =
        values.questionbank_programme_subjects;

      return values;
    },
    schema: {
      type: "object",
      properties: {
        title: {
          type: "string",
          placeholder: "Title",
          rules: [
            {
              validator(rule, value) {
                if (!isStringEmpty(value)) {
                  return Promise.resolve();
                } else {
                  return Promise.reject("Please enter title");
                }
              },
            },
          ],
        },
        code: {
          type: "string",
          default: "",
          wrapClassName: isDistrict ? "hidden" : "",
          placeholder: "Code",
        },
        programme_id: {
          title: "Select program",
          type: "string",
          span: 24,
          widget: isDistrict ? SelectOrgProgram : SelectProgram,
          rules: [{
            required: true,
            message: mrIntl("CommonText.required_msg"),
          }]
        },
        questionbank_programme_subjects: {
          type: "string",
          dependsOn: ["programme_id"],
          children: QBProgrammeSubjectsChildComponent,
        },
        selected_orgs: {
          type: "string",
          wrapClassName: isDistrict ? "" : "hidden",
          widget: SelectOrgsChildComponent,
        },
        settings: {
          type: "object",
          properties: {
            visible_for_role: {
              title: "Visible for role",
              type: "string",
              span: 24,
              default: "admin_teacher",
              widget: "RadioGroupWidget",
              widgetConfig: {
                options: [
                  {
                    label: "Admin",
                    value: "admin",
                  },
                 {
                  label: "Admin & Teacher",
                  value: "admin_teacher",
                 },
                ],
              }
            },
            dups_editable: {
              title: "Duplicates editable for users?",
              type: "string",
              span: 24,
              default: false,
              widget: "RadioGroupWidget",
              widgetConfig: {
                options: [
                  {
                    label: "Yes",
                    value: true,
                  },
                  {
                    label: "No",
                    value: false,
                  },
                ],
              },
            },
            preserve_start_conditions_on_duplicate: {
              title: "Preserve start conditions on duplicate? [only use with dups_editable false - for CA]",
              type: "string",
              span: 24,
              default: false,
              widget: "RadioGroupWidget",
              widgetConfig: {
                options: [
                  {
                    label: "Yes",
                    value: true,
                  },
                  {
                    label: "No",
                    value: false,
                  },
                ],
              },
            },
            // allow_orgs: {
            //   title: "Allow orgs to add to bank?",
            //   type: "string",
            //   span: 6,
            //   default: false,
            //   widget: "RadioGroupWidget",
            //   widgetConfig: {
            //     options: [
            //       {
            //         label: "Yes",
            //         value: true,
            //       },
            //       {
            //         label: "No",
            //         value: false,
            //       },
            //     ],
            //   },
            // }, 
          },
        },
      },
    },
  };
  return form;
};
 
const processQuestionBankInitialValues = (data, opts) => {
  let newData = {...data}
  const { formProps = {} } = opts
  const { currentUser = {} } = formProps
  const isDistrict = currentUser.org.org_type === "district"
  if (isDistrict && data?.org_questionbanks) {
    let selectedOrgs = [] 
    data.org_questionbanks.map((item) => {
      if (item.org_id && item.org_id !== currentUser.org_id) {
        selectedOrgs.push(item.org_id)
      }
    });
    newData.selected_orgs = selectedOrgs
  }
  return newData;
}

const Questionbanks = MrCrudView({
  resourceName: "questionbanks",
  singleResourceName: "questionbank",
  // displayName: "Create/Edit Questionbank",
  resourceUrl: "/questionbanks",
  // filter: BoardsFilter,
  isRoute: true,
  selectorsObj: {
    ...commonSelectors,
  },
  // listItem: BoardListItem,
  forms: [{ name: "questionbanks", form: returnForm, config: {processInitialValues: processQuestionBankInitialValues}}],
  actions,
  actionNames: ["fetch", "create", "show", "update", "delete"],
  // firstTimeFetchParams: { with_users: true }
  config: {
    itemPreview: {
      widget: (props) => {
        console.log("itemDetail props", props);
        return <span>Item Detail {JSON.stringify(props.item)}</span>;
      },
    },
    itemDetail: {
      widget: (props) => {
        console.log("itemDetail props", props);
        return <span>Item Detail {JSON.stringify(props.item)}</span>;
      },
      // widget: ProgrammeItemDetail,
    },
    pagination: {
      show: true,
    },
    filter: {
      show: true,
      widget: (props) => {
        return <span>Filter</span>;
      },
    },
    core: {
      setQueryParams: true,
    },
    list: {
      show: true,
      type: "table/list/custom",
      widget: QuestionbanksList,
      // widget: (props) => {
      // return <span>List</span>;
      // },
    },
  },
});

// Questionbanks.defaultProps = {};

Questionbanks.propTypes = {};
export default Questionbanks;
